import { SECONDARY_SECTION_LIST_NEW } from "@components/Modules/HeaderNew/headerMenuConstants";
import { HeaderMenuList } from "@components/Modules/HeaderNew/HeaderMenuList";
import { type ReactElement } from "react";

export type SecondaryLinksProps = Readonly<{
  testId?: string;
}>;

export function SecondaryLinks({
  testId = "desktop-secondary-links",
}: SecondaryLinksProps): ReactElement {
  return (
    <div
      data-testid={`${testId}-secondaryLinks`}
      className={`hidden lg:flex justify-end lg:w-[992px] xl:w-[1197px] lg:pr-[60px]`}
    >
      <div data-testid={`${testId}-secondaryLinksInner`}>
        <HeaderMenuList
          testId={testId}
          items={SECONDARY_SECTION_LIST_NEW}
          type="secTopics"
        />
      </div>
    </div>
  );
}
